import { Component, Input, OnChanges, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { State } from '@app/core/ngrx/reducers';
import { paymentSelectors, userSelectors } from '@app/core/ngrx/selectors';
import { NavController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { PipesComponentsModule } from '@app/shared/pipes/pipes.modules';
@Component({
    selector: 'app-payment-stripe-summary',
    templateUrl: './payment-stripe-summary.component.html',
    styleUrls: ['./payment-stripe-summary.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, ImgPipe, PipesComponentsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaymentStripeSummaryComponent implements OnChanges {
    sliderOpts = {
        initialSlide: 0,
        speed: 400,
        scrollbar: true,
        slidesPerView: 1,
        centeredSlides: true,
    };

    @Input() application?: any;

    constructor(private store: Store<State>, private navController: NavController) {}

    ngOnChanges() {
        console.log('SUMMARY APPLICATION: ', this.application);
    }

    viewProgram(id: string) {
        this.navController.navigateForward([`/program/${id}`]);
    }
}
